import ACTIONS from "../constants/actions";

const {
  GET_TOTAL_USER_WORKING,
  GET_TOTAL_USER_WORKING_SUCCESS,
  GET_TOTAL_USER_WORKING_FAIL,
  GET_CURRENT_USER_WORKING,
  GET_CURRENT_USER_WORKING_SUCCESS,
  GET_CURRENT_USER_WORKING_FAIL,
  GET_WORKING_CHART,
  GET_WORKING_CHART_SUCCESS,
  GET_WORKING_CHART_FAIL,
  GET_USER_ANALYSIS_DETAIL,
  GET_USER_ANALYSIS_DETAIL_SUCCESS,
  GET_USER_ANALYSIS_DETAIL_FAIL,
  GET_USER_WORKING_DAYS,
  GET_USER_WORKING_DAYS_SUCCESS,
  GET_USER_WORKING_DAYS_FAIL,
  GET_USER_LATENCY,
  GET_USER_LATENCY_SUCCESS,
  GET_USER_LATENCY_FAIL,
  GET_USER_REASON,
  GET_USER_REASON_SUCCESS,
  GET_USER_REASON_FAIL,
  GET_USER_LOCATION_ANALYSIS,
  GET_USER_LOCATION_ANALYSIS_SUCCESS,
  GET_USER_LOCATION_ANALYSIS_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingTotalUserWorking: true,
  totalUserWorking: [],
  isLoadingCurrentUserWorking: true,
  currentUserWorking: [],
  isLoadingWorkingChart: true,
  workingChart: [],
  isLoadingUserAnalysisDetail: true,
  userAnalysisDetail: {},
  isLoadingUserWorkingDays: true,
  userWorkingDays: {},
  isLoadingUserLatency: false,
  userLatency: {},
  isLoadingUserReason: true,
  userReason: [],
  idLoadingUserLocation: true,
  userLocation: [],

  // isLoadingUsersWorking: true,
  // listUsersWorking: [],
  // isLoadingCurrentUsers: true,
  // listCurrentUsers: [],
};

const analysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOTAL_USER_WORKING:
      return {
        ...state,
        isLoadingTotalUserWorking: true,
      };
    case GET_TOTAL_USER_WORKING_SUCCESS:
      return {
        ...state,
        isLoadingTotalUserWorking: false,
        totalUserWorking: action.payload,
      };
    case GET_TOTAL_USER_WORKING_FAIL:
      return {
        isLoadingTotalUserWorking: false,
        ...state,
      };

    case GET_CURRENT_USER_WORKING:
      return {
        ...state,
        isLoadingCurrentUserWorking: true,
      };
    case GET_CURRENT_USER_WORKING_SUCCESS:
      return {
        ...state,
        isLoadingCurrentUserWorking: false,
        currentUserWorking: action.payload,
      };
    case GET_CURRENT_USER_WORKING_FAIL:
      return {
        isLoadingCurrentUserWorking: false,
        ...state,
      };

    case GET_WORKING_CHART:
      return {
        ...state,
        isLoadingWorkingChart: true,
      };
    case GET_WORKING_CHART_SUCCESS:
      return {
        ...state,
        isLoadingWorkingChart: false,
        workingChart: action.payload,
      };
    case GET_WORKING_CHART_FAIL:
      return {
        isLoadingWorkingChart: false,
        ...state,
      };

    case GET_USER_ANALYSIS_DETAIL:
      return {
        ...state,
        isLoadingUserAnalysisDetail: true,
      };
    case GET_USER_ANALYSIS_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingUserAnalysisDetail: false,
        userAnalysisDetail: action.payload,
      };
    case GET_USER_ANALYSIS_DETAIL_FAIL:
      return {
        isLoadingUserAnalysisDetail: false,
        ...state,
      };

    case GET_USER_WORKING_DAYS:
      return {
        ...state,
        isLoadingUserWorkingDays: true,
      };
    case GET_USER_WORKING_DAYS_SUCCESS:
      return {
        ...state,
        isLoadingUserWorkingDays: false,
        userWorkingDays: action.payload,
      };
    case GET_USER_WORKING_DAYS_FAIL:
      return {
        isLoadingUserWorkingDays: false,
        ...state,
      };

    case GET_USER_LATENCY:
      return {
        ...state,
        isLoadingUserLatency: true,
      };
    case GET_USER_LATENCY_SUCCESS:
      return {
        ...state,
        isLoadingUserLatency: false,
        userLatency: action.payload,
      };
    case GET_USER_LATENCY_FAIL:
      return {
        isLoadingUserLatency: false,
        ...state,
      };

    case GET_USER_REASON:
      return {
        ...state,
        isLoadingUserReason: true,
      };
    case GET_USER_REASON_SUCCESS:
      return {
        ...state,
        isLoadingUserReason: false,
        userReason: action.payload,
      };
    case GET_USER_REASON_FAIL:
      return {
        isLoadingUserReason: false,
        ...state,
      };

    case GET_USER_LOCATION_ANALYSIS:
      return {
        ...state,
        idLoadingUserLocation: true,
      };
    case GET_USER_LOCATION_ANALYSIS_SUCCESS:
      return {
        ...state,
        idLoadingUserLocation: false,
        userLocation: action.payload,
      };
    case GET_USER_LOCATION_ANALYSIS_FAIL:
      return {
        idLoadingUserLocation: false,
        ...state,
      };

    default:
      return state;
  }
};
export default analysisReducer;
